import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import Pages from '../pages/allPages'
import Home from '../pages/home'
import Index from '../pages/index'
import Spot from '../pages/spot'
import Login from '../pages/login'
import Register from '../pages/register'
import Forgotpassword from '../pages/forgotpassword'
import My from '../pages/my'
import Fund from '../pages/fund'
import Trusteeship from '../pages/trusteeship'
import Rule from '../pages/rule'
import Recharge  from '../pages/recharge'
import Withdrawal from '../pages/withdrawal'
import Fundorder from '../pages/fundorder'
import Sustainable from '../pages/sustainable'
import Asset from '../pages/asset'
import Authentication from '../pages/authentication'
import HelpDetail from '../pages/helpDetail'
import Transfer from '../pages/transfer'
import Exchange from '../pages/exchange'


export default new Router({
    routes: [{
        path: '/',
        redirect: '/pages/home/index',
    }, {
        path: '/pages',
        component: Pages,
        children: [{
            path: '/pages/home',
            component: Home,
            children: [{
                path: '/pages/home/index',//首页
                component: Index
            },{
                path: '/pages/home/spot',//币币交易
                component: Spot
            }]
        },{
            path: '/pages/login', //登录
            component: Login
        },{
            path: '/pages/register', //注册
            component: Register
        },{
            path: '/pages/forgotpassword', //忘记密码
            component: Forgotpassword
        },{
            path: '/pages/my', //我的
            component: My
        },{
            path: '/pages/fund', //理财
            component: Fund
        },{
            path: '/pages/trusteeship', //托管订单
            component: Trusteeship
        },{
            path: '/pages/rule', //规则
            component: Rule
        },{
            path: '/pages/recharge', //充币
            component: Recharge
        },{
            path: '/pages/withdrawal', //提币
            component: Withdrawal
        },{
            path: '/pages/fundorder', //理财订单记录
            component: Fundorder
        },{
            path: '/pages/sustainable', //永续合约
            component: Sustainable
        },{
            path: '/pages/asset', //个人中心
            component: Asset
        },{
            path: '/pages/helpDetail', //身份认证
            component: HelpDetail
        },{
            path: '/pages/transfer', //划转
            component: Transfer
        },{
            path: '/pages/exchange', //闪兑
            component: Exchange
        }]
    }]
})


// WEBPACK FOOTER //
// ./src/router/index.js